import { ProgressBar } from 'primereact/progressbar'
// import { Flex } from './Flex'

export const ProgressBarComponent = ({ value, total, color }) => {
  // const valueTemplate = (value) => <>{(value / 100) * total}/{total}</>
  const calculateValue = (value) => ((value * 100) / total).toFixed(2)

  return <ProgressBar value={calculateValue(value)} color={color} style={{ width: '80%' }} />
}
